/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Error from '../model/Error';
import InlineResponse2002 from '../model/InlineResponse2002';
import InlineResponse2003 from '../model/InlineResponse2003';
import InlineResponse2004 from '../model/InlineResponse2004';
import StudentAcademicRecordTitle from '../model/StudentAcademicRecordTitle';

/**
* StudentAcademicProgramsTitle service.
* @module api/StudentAcademicProgramsTitleApi
* @version 1.0
*/
export default class StudentAcademicProgramsTitleApi {

    /**
    * Constructs a new StudentAcademicProgramsTitleApi. 
    * @alias module:api/StudentAcademicProgramsTitleApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * get ACE student academic programs title
     * @param {Number} studentId 
     * @param {Number} academicProgramId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse2004} and HTTP response
     */
    studentAcademicProgramTitleDocumentAceControllerShowByStudentWithHttpInfo(studentId, academicProgramId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling studentAcademicProgramTitleDocumentAceControllerShowByStudent");
      }
      // verify the required parameter 'academicProgramId' is set
      if (academicProgramId === undefined || academicProgramId === null) {
        throw new Error("Missing the required parameter 'academicProgramId' when calling studentAcademicProgramTitleDocumentAceControllerShowByStudent");
      }

      let pathParams = {
        'student_id': studentId
      };
      let queryParams = {
        'academic_program_id': academicProgramId
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = InlineResponse2004;
      return this.apiClient.callApi(
        '/student-academic-programs-title/students/{student_id}/ace', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * get ACE student academic programs title
     * @param {Number} studentId 
     * @param {Number} academicProgramId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse2004}
     */
    studentAcademicProgramTitleDocumentAceControllerShowByStudent(studentId, academicProgramId) {
      return this.studentAcademicProgramTitleDocumentAceControllerShowByStudentWithHttpInfo(studentId, academicProgramId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Upload ACE ACEdocumentation
     * @param {String} studentId 
     * @param {Object} opts Optional parameters
     * @param {File} opts.file Archivo a subir
     * @param {Number} opts.academicProgramId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse2002} and HTTP response
     */
    studentAcademicProgramTitleDocumentAceControllerStoreWithHttpInfo(studentId, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling studentAcademicProgramTitleDocumentAceControllerStore");
      }

      let pathParams = {
        'student_id': studentId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'file': opts['file'],
        'academic_program_id': opts['academicProgramId']
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = InlineResponse2002;
      return this.apiClient.callApi(
        '/student-academic-programs-title/students/{student_id}/ace', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Upload ACE ACEdocumentation
     * @param {String} studentId 
     * @param {Object} opts Optional parameters
     * @param {File} opts.file Archivo a subir
     * @param {Number} opts.academicProgramId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse2002}
     */
    studentAcademicProgramTitleDocumentAceControllerStore(studentId, opts) {
      return this.studentAcademicProgramTitleDocumentAceControllerStoreWithHttpInfo(studentId, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * get student academic programs title from mad by student
     * @param {Number} studentId 
     * @param {Number} academicProgramId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse2003} and HTTP response
     */
    studentAcademicProgramTitleDocumentControllerShowByStudentWithHttpInfo(studentId, academicProgramId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling studentAcademicProgramTitleDocumentControllerShowByStudent");
      }
      // verify the required parameter 'academicProgramId' is set
      if (academicProgramId === undefined || academicProgramId === null) {
        throw new Error("Missing the required parameter 'academicProgramId' when calling studentAcademicProgramTitleDocumentControllerShowByStudent");
      }

      let pathParams = {
        'student_id': studentId
      };
      let queryParams = {
        'academic_program_id': academicProgramId
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = InlineResponse2003;
      return this.apiClient.callApi(
        '/student-academic-programs-title/students/{student_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * get student academic programs title from mad by student
     * @param {Number} studentId 
     * @param {Number} academicProgramId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse2003}
     */
    studentAcademicProgramTitleDocumentControllerShowByStudent(studentId, academicProgramId) {
      return this.studentAcademicProgramTitleDocumentControllerShowByStudentWithHttpInfo(studentId, academicProgramId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * get tar from id
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/StudentAcademicRecordTitle} and HTTP response
     */
    studentAcademicProgramTitleDocumentControllerShowCurrentWithHttpInfo(id) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling studentAcademicProgramTitleDocumentControllerShowCurrent");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = StudentAcademicRecordTitle;
      return this.apiClient.callApi(
        '/student-academic-programs-title/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * get tar from id
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/StudentAcademicRecordTitle}
     */
    studentAcademicProgramTitleDocumentControllerShowCurrent(id) {
      return this.studentAcademicProgramTitleDocumentControllerShowCurrentWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Upload documentation
     * @param {Number} studentId 
     * @param {File} file 
     * @param {Number} academicProgramId 
     * @param {Date} payedAt 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
    studentAcademicProgramTitleDocumentControllerStoreWithHttpInfo(studentId, file, academicProgramId, payedAt) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling studentAcademicProgramTitleDocumentControllerStore");
      }
      // verify the required parameter 'file' is set
      if (file === undefined || file === null) {
        throw new Error("Missing the required parameter 'file' when calling studentAcademicProgramTitleDocumentControllerStore");
      }
      // verify the required parameter 'academicProgramId' is set
      if (academicProgramId === undefined || academicProgramId === null) {
        throw new Error("Missing the required parameter 'academicProgramId' when calling studentAcademicProgramTitleDocumentControllerStore");
      }
      // verify the required parameter 'payedAt' is set
      if (payedAt === undefined || payedAt === null) {
        throw new Error("Missing the required parameter 'payedAt' when calling studentAcademicProgramTitleDocumentControllerStore");
      }

      let pathParams = {
        'student_id': studentId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'file': file,
        'academic_program_id': academicProgramId,
        'payed_at': payedAt
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['multipart/form-data'];
      let accepts = [];
      let returnType = null;
      return this.apiClient.callApi(
        '/student-academic-programs-title/students/{student_id}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Upload documentation
     * @param {Number} studentId 
     * @param {File} file 
     * @param {Number} academicProgramId 
     * @param {Date} payedAt 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
    studentAcademicProgramTitleDocumentControllerStore(studentId, file, academicProgramId, payedAt) {
      return this.studentAcademicProgramTitleDocumentControllerStoreWithHttpInfo(studentId, file, academicProgramId, payedAt)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
